import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { hidePDPAPopup, submitPDPAConsent, getPDPAPolicy } from '../actions/auth/index';

class PDPAConsentPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      policyContent: null,
      isAccepted: false,
      isLoading: false,
      error: null
    };
    this.handleAcceptChange = this.handleAcceptChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.loadPolicyContent = this.loadPolicyContent.bind(this);
  }

  componentDidMount() {
    this.loadPolicyContent();
  }

  async loadPolicyContent() {
    try {
      this.setState({ isLoading: true, error: null });
      const policyData = await this.props.getPDPAPolicy();
      this.setState({
        policyContent: policyData.content,
        isLoading: false
      });
    } catch (error) {
      this.setState({
        error: 'ไม่สามารถโหลดนโยบายความเป็นส่วนตัวได้ กรุณาลองใหม่อีกครั้ง',
        isLoading: false
      });
    }
  }

  handleAcceptChange(e) {
    this.setState({ isAccepted: e.target.checked });
  }

  async handleSubmit(e) {
    e.preventDefault();
    if (!this.state.isAccepted) {
      return;
    }

    try {
      this.setState({ isLoading: true, error: null });
      await this.props.submitPDPAConsent();
      this.setState({ isLoading: false });
    } catch (error) {
      this.setState({
        error: this.props.pdpaConsentError || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
        isLoading: false
      });
    }
  }

  render() {
    const { showPDPAPopup } = this.props;
    const { policyContent, isAccepted, isLoading, error } = this.state;

    if (!showPDPAPopup) {
      return null;
    }

    return (
      <div className="bt-popup-backdrop">
        <div className="bt-popup bt-popup-pdpa">
          <div className="pdpa-container" onClick={(e) => e.stopPropagation()}>
            {/* Header */}
            <div className="pdpa-header">
              <div className="pdpa-title">
                <FontAwesomeIcon icon={["fas", "shield-alt"]} className="pdpa-icon" />
                <h2>นโยบายความเป็นส่วนตัว</h2>
              </div>
              <button
                className="pdpa-close-btn"
                onClick={() => this.props.hidePDPAPopup()}
                aria-label="ปิด"
              >
                <FontAwesomeIcon icon={["far", "times"]} />
              </button>
            </div>

            {/* Content */}
            <div className="pdpa-content">
              {isLoading && !policyContent ? (
                <div className="pdpa-loading">
                  <div className="loading-spinner">
                    <div className="spinner"></div>
                  </div>
                  <p>กำลังโหลดนโยบายความเป็นส่วนตัว...</p>
                </div>
              ) : error ? (
                <div className="pdpa-error">
                  <FontAwesomeIcon icon={["fas", "exclamation-triangle"]} className="error-icon" />
                  <p>{error}</p>
                  <button
                    className="pdpa-btn pdpa-btn-retry"
                    onClick={this.loadPolicyContent}
                  >
                    ลองใหม่อีกครั้ง
                  </button>
                </div>
              ) : (
                <>
                  {/* Policy Content */}
                  <div className="pdpa-policy-section">
                    <div className="policy-header">
                      <FontAwesomeIcon icon={["fas", "file-alt"]} className="policy-icon" />
                      <h3>นโยบายความเป็นส่วนตัวสำหรับลูกค้า</h3>
                    </div>
                    <div
                      className="policy-content"
                      dangerouslySetInnerHTML={{ __html: policyContent }}
                    />
                  </div>

                  {/* Consent Form */}
                  <div className="pdpa-consent-section">
                    <form onSubmit={this.handleSubmit}>
                      <div className="consent-checkbox">
                        <label className="checkbox-container">
                          <input
                            type="checkbox"
                            checked={isAccepted}
                            onChange={this.handleAcceptChange}
                            required
                          />
                          <span className="checkmark"></span>
                          <span className="consent-text">
                            ฉันได้อ่านและยอมรับนโยบายความเป็นส่วนตัวแล้ว
                          </span>
                        </label>
                      </div>

                      {this.props.pdpaConsentError && (
                        <div className="pdpa-error-message">
                          <FontAwesomeIcon icon={["fas", "exclamation-circle"]} />
                          <span>{this.props.pdpaConsentError}</span>
                        </div>
                      )}

                      <button
                        type="submit"
                        className={`pdpa-btn pdpa-btn-accept ${!isAccepted ? 'disabled' : ''}`}
                        disabled={!isAccepted || isLoading}
                      >
                        {isLoading ? (
                          <>
                            <div className="btn-spinner"></div>
                            กำลังส่งข้อมูล...
                          </>
                        ) : (
                          <>
                            <FontAwesomeIcon icon={["far", "check"]} />
                            ยอมรับ
                          </>
                        )}
                      </button>
                    </form>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    showPDPAPopup: state.auth.showPDPAPopup,
    pdpaConsentError: state.auth.pdpaConsentError
  }
}

export default connect(mapStateToProps, {
  hidePDPAPopup,
  submitPDPAConsent,
  getPDPAPolicy
})(PDPAConsentPopup); 